@if (isDialogVisible()) {
	<app-modal (closed)="endSession()" [closeVisible]="true" [narrow]="true" [standaloneDialog]="true">
		<div class="text-center">
			<h2 class="text-2xl font-bold idle-session-modal-title mb-4">Jūsų sesija netrukus baigsis</h2>
			<p class="idle-session-modal-text leading-relaxed mb-8">
				Dėl jūsų saugumo jus automatiškai atjungiame, kai tam tikrą laiką neatliekate jokių veiksmų. Spauskite "Tęsti"
				norėdami tęsti darbą arba Spauskite "Atsijungti", kad baigtumėte sesiją.
			</p>
			<app-count-down (timerFinished)="endSession()" [timerSeconds]="warningDurationSec"></app-count-down>
		</div>
		<ng-container footer>
			<div class="grid grid-cols-2 gap-4">
				<app-button (clicked)="endSession()" severity="secondary">Atsijungti</app-button>
				<app-button (clicked)="continueSession()" severity="primary">Tęsti</app-button>
			</div>
		</ng-container>
	</app-modal>
}
